import { WithBranchParams } from "~/_legacy/types/params";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string, floorPlanId: number, memoDiagramId: number) =>
  `branches/${branchUid}/floor-plans/${floorPlanId}/rects/${memoDiagramId}/`;

export const deleteFloorPlanMemoDiagram = async ({
  branchUid,
  branchVersionId,
  floorPlanId,
  memoDiagramId,
}: WithBranchParams<{
  floorPlanId: number;
  memoDiagramId: number;
}>) => {
  const url = createApiUrl(branchUid, floorPlanId, memoDiagramId);
  const { data } = await axiosInstance.delete(url, {
    params: {
      version: branchVersionId,
    },
  });

  return data;
};
